import React, { Component } from "react";
import {
  Select,
  Table,
  DatePicker,
  Modal,
  message,
  Tooltip,
  Input,
  Radio
} from "antd";
import { EditOutlined } from "@ant-design/icons";

import Loader from "../../loader";
import Fetch from "../../../utils/fetch";
import fetchCached, { SHORT_TTL } from "../../../utils/cachedFetch";
import Search from "../operatorSearch";
import moment from "moment";
import less from "./trips.module.scss";
import jwtDecode from "jwt-decode";
import { getSeatNumberFromTripChart } from "../../../utils/common";
import TrackCabModal from "../trackCabModal";

const { Option } = Select;

const CAB_TRIP_STATUS_LABELS = {
  ACTIVE: "ACTIVE",
  ONTRIP: "ON TRIP",
  COMPLETED: "COMPLETED",
  INACTIVE: "INACTIVE"
};
// A trip in one of these has started and can never go back to INACTIVE
const STARTED_TRIP_STATUSES = ["ONTRIP", "COMPLETED"];
// A row click on one of these is that element's own action, not Track Cab
const INTERACTIVE_TAGS = [
  "BUTTON",
  "A",
  "INPUT",
  "TEXTAREA",
  "SELECT",
  "LABEL",
  "IMG",
  "SVG"
];

const columns = [
  {
    title: "Route",
    dataIndex: "route",
    key: "route",
    width: "10%",
    render: ({ fromCity, toCity }) => (
      <>
        <span>{fromCity}</span>
        <br />
        <span>{toCity}</span>
      </>
    )
  },
  {
    title: "Trip ID",
    dataIndex: "tripId",
    key: "tripId",
    width: "15%",
    render: ({ value, copy }) => (
      <div className={less.tripTable}>
        <span>{value}</span>
        <img
          onClick={() => copy(value)}
          src="https://d1flzashw70bti.cloudfront.net/original/images/tarcer/copy.svg"
          alt="copy"
        />
      </div>
    )
  },
  {
    title: "Start Time & Date",
    dataIndex: "date",
    key: "date",
    width: "10%"
  },
  {
    title: "Type",
    dataIndex: "type",
    key: "type",
    width: "10%"
  },
  {
    title: "Seats",
    dataIndex: "seat",
    key: "seat",
    width: "10%",
    render: ({ value }) => (
      <div>
        <span>{value}</span>
      </div>
    )
  },

  {
    title: "Boarded / Not-Boarded",
    dataIndex: "countBnB",
    key: "countBnB",
    width: "10%"
  },
  {
    title: "Invoice",
    dataIndex: "invoice",
    key: "invoice",
    width: "10%",
    render: ({ stage, invoiceNumber }) => (
      <div className={less.invoiceTable}>
        <p>{stage ? stage.replaceAll("_", " ") : ""}</p>
        <p>{invoiceNumber ? `(${invoiceNumber})` : ""}</p>
      </div>
    )
  },
  {
    title: "Asset Type",
    dataIndex: "assetType",
    key: "assetType",
    width: "10%"
  },
  {
    title: "Operator",
    dataIndex: "operator",
    key: "operator",
    width: "10%"
  },
  {
    title: "Amount",
    dataIndex: "amount",
    key: "amount",
    width: "10%",
    render: ({ value, onAmountEdit, status, alert, _id, InvoiceStatus }) => (
      <div className={less.amountDiv}>
        {status == "CONTRACT_AVAILABLE" ? (
          <span>₹{value}</span>
        ) : (
          <span style={{ color: alert }}>{status}</span>
        )}
        {status === "Trip Not Started" ||
        status == "Trip Deactivated " ||
        InvoiceStatus !== "REJECTED" ? null : (
          <EditOutlined onClick={() => onAmountEdit(_id)} />
        )}
      </div>
    )
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    width: "10%",
    render: ({ value }) => (
      <div className={less.statusDiv}>
        <div
          className={
            value === "ACTIVE"
              ? less.statusActive
              : value === "ONTRIP"
              ? less.statusOnTrip
              : value === "COMPLETED"
              ? less.statusCompleted
              : less.statusInActive
          }
        ></div>
        <span>{CAB_TRIP_STATUS_LABELS[value] || value}</span>
      </div>
    )
  },
  {
    title: "Assign",
    dataIndex: "assign",
    key: "assign",
    width: "15%",
    render: ({
      isDriverDetailAvailable,
      assign,
      _id,
      isAssigned,
      driverDetails,
      status,
      type
    }) => (
      <div className={less.assignTable}>
        {isAssigned ? (
          <div className={less.isAssigned}>
            <img
              src="https://d1flzashw70bti.cloudfront.net/original/images/tracer/accept.svg"
              alt="accept"
            />
            <span>Assigned</span>
            {isDriverDetailAvailable ? (
              <Tooltip
                title={driverDetails}
                overlayStyle={{
                  backgroundColor: "transparent", // Make background transparent
                  borderRadius: "8px", // Add border-radius
                  border: "1px solid rgba(0, 0, 0, 0.1)" // Optional: add a subtle border if you want
                }}
                trigger={"click"}
              >
                <img
                  src="https://d1flzashw70bti.cloudfront.net/original/images/tracer/tooltip.svg"
                  alt="tooltip"
                />
              </Tooltip>
            ) : null}
          </div>
        ) : type === "DYNAMIC" ? (
          <div className={less.notAssigned} onClick={() => assign(_id, status)}>
            {" "}
            <span>Assign</span>
          </div>
        ) : (
          <div
            className={less.notAssigned}
            style={{
              pointerEvents: "none",
              opacity: 0.5,
              cursor: "not-allowed"
            }}
          >
            {" "}
            <span>Assign</span>
          </div>
        )}
      </div>
    )
  },
  {
    title: "Contract Type",
    dataIndex: "variableType",
    key: "variableType",
    width: "10%",
    render: ({ type, _id }) => (
      <div className={less.assignTable}>
        <div className={less.isAssigned}>
          <span>{type}</span>
          {type === "FIXED" ? (
            <Tooltip
              title={_id}
              overlayStyle={{
                backgroundColor: "transparent", // Make background transparent
                borderRadius: "8px", // Add border-radius
                border: "1px solid rgba(0, 0, 0, 0.1)" // Optional: add a subtle border if you want
              }}
              trigger={"click"}
            >
              <img
                src="https://d1flzashw70bti.cloudfront.net/original/images/tracer/tooltip.svg"
                alt="tooltip"
              />
            </Tooltip>
          ) : null}
        </div>
      </div>
    )
  },
  {
    title: "Track Cab",
    dataIndex: "trackCab",
    key: "trackCab",
    width: "7%",
    render: ({ _id, open }) => (
      <div className={less.editTable}>
        <div onClick={() => open(_id)}>
          <span>Show</span>
        </div>
      </div>
    )
  },
  {
    title: "Actions",
    dataIndex: "actions",
    key: "actions",
    width: "10%",
    render: ({ canEdit, edit, logs, _id, InvoiceStatus }) => (
      <div className={less.editTable}>
        {InvoiceStatus !== "REJECTED" ? null : (
          <div onClick={() => edit(_id, canEdit)}>
            <span>Edit</span>
          </div>
        )}
        <div onClick={() => logs(_id)}>
          <span>Logs</span>
        </div>
      </div>
    )
  }
];

class OperatorCabTrip extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      operatorTableData: [],
      expandedRowsData: {},
      showEditModal: false,
      showCreateModal: false,
      editData: {},
      updateSupply: {},
      showLogModal: false,
      showSupplyModal: false,
      expandedRowKeys: [],
      cities: [],
      coreServiceNames: {},
      expandedBookings: {},
      variableType: "DYNAMIC",
      trackCabGroupId: null
    };
  }

  openTrackCab = cabBookingGroupId =>
    this.setState({ trackCabGroupId: cabBookingGroupId });

  // A row click opens Track Cab, like a row click on Tracer's bus list,
  // unless it landed on something clickable in the row (copy and edit icons,
  // assign, edit, logs, the expand caret, inputs)
  getRowProps = record => ({
    onClick: event => {
      const row = event.currentTarget;
      for (let el = event.target; el && el !== row; el = el.parentElement) {
        const tag = el.tagName.toUpperCase();
        const { cursor } = window.getComputedStyle(el);
        if (
          INTERACTIVE_TAGS.includes(tag) ||
          el.classList.contains("anticon") ||
          cursor === "pointer" ||
          cursor === "not-allowed"
        ) {
          return;
        }
      }
      this.openTrackCab(record.key);
    }
  });

  async componentDidMount() {
    try {
      const response = await this.fetchData();
      const cabOperators = await this.fetchOperators();

      const { cities } = this.props;
      const activeCities = cities.filter(city => city.status == "ACTIVE");

      const token = localStorage.getItem("idToken");
      const decodedToken = jwtDecode(token);
      const last_mile_admin =
        Array.isArray(decodedToken.privileges) &&
        decodedToken.privileges.includes("last_mile_admin");

      this.setState({
        cabOperators,
        operatorTableData: response.data,
        operatorData: response.allResponse,
        loading: false,
        cities: activeCities,
        assetTypeValues: [],
        last_mile_admin,
        userName: decodedToken.name
      });
    } catch (err) {
      console.log(err);
      this.setState({ loading: false });
    }
  }
  fetchData = async () => {
    try {
      const url = `/cabOperator/trips`;

      const options = {
        method: "get"
      };
      let allResponse = await Fetch(url, options);
      let data = [];

      if (Array.isArray(allResponse) && allResponse.length > 0) {
        data = this.formatData(allResponse);
      } else {
        allResponse = [];
      }

      return { data, allResponse };
    } catch (err) {
      console.log(err);
      message.error(err);
    }
  };

  sortData = data => {
    const currentTime = Date.now();

    data.sort((a, b) => {
      if (a.status === "ACTIVE" && b.status !== "ACTIVE") {
        return -1;
      }
      if (a.status !== "ACTIVE" && b.status === "ACTIVE") {
        return 1;
      }

      if (a.startTime > currentTime && b.startTime <= currentTime) {
        return -1;
      }
      if (a.startTime <= currentTime && b.startTime > currentTime) {
        return 1;
      }

      return a.startTime - b.startTime;
    });

    return data;
  };

  countTotalSeatsInTrip(trip) {
    let totalSeats = 0;
    trip.bookings.forEach(booking => {
      totalSeats += booking.tripChart.length;
    });

    return totalSeats;
  }

  formatData = values => {
    const sortedData = this.sortData(values);
    let tableData = sortedData.map(value => {
      let totalBoardedCount = 0;
      if (value.boaredCoreBooking) {
        totalBoardedCount = value.boaredCoreBooking.reduce(
          (sum, booking) => sum + booking.noOfSeats,
          0
        );
      }
      const totalSeats = this.countTotalSeatsInTrip(value);
      const NotBoardedCount = totalSeats - totalBoardedCount;
      let canEdit = Date.now() <= value.startTime;
      const boardedBookingIds =
        value.boaredCoreBooking && value.boaredCoreBooking.length > 0
          ? value.boaredCoreBooking.map(booking => booking.bookingId)
          : [];
      const booking = value.bookings.map(data => {
        return {
          ...data,
          isOnboarded: boardedBookingIds.includes(data._id) ? true : false
        };
      });

      let data = {
        key: value._id,
        route: {
          fromCity: value.fromCity.name,
          toCity: value.toCity.name
        },
        invoice: {
          stage:
            value.invoice && value.invoice.stage ? value.invoice.stage : null,
          invoiceNumber:
            value.invoice && value.invoice.invoiceNumber
              ? value.invoice.invoiceNumber
              : null
        },
        countBnB: `${totalBoardedCount}/${NotBoardedCount}`,
        tripId: { value: value.groupCode, copy: this.copyData },
        date: moment(value.startTime).format("h:mm a, DD MMM YY"),
        type: value.isIntraCity ? "Intra" : "Inter",
        seat: { value: totalSeats },
        assetType: value.assetType,
        operator: value.cabOperator ? value.cabOperator.name : null,
        status: {
          value: value.status
        },
        amount: {
          value: value.supplyCost,
          _id: value._id,
          InvoiceStatus:
            value.invoice && value.invoice.status
              ? value.invoice.status
              : "REJECTED",
          status:
            value.status === "INACTIVE"
              ? "Trip Deactivated "
              : !canEdit
              ? value.supplyCostStatus === "CONTRACT_AVAILABLE" ||
                value.supplyCostStatus === "SUPPLY_COST_MANUALLY_UPDATED"
                ? "CONTRACT_AVAILABLE"
                : value.supplyCostStatus === "CONTRACT_EXPIRED"
                ? "Contract Expired"
                : "No Contract Avalaible"
              : "Trip Not Started",
          alert:
            value.status === "INACTIVE"
              ? " #DD310E"
              : !canEdit
              ? value.supplyCostStatus === "CONTRACT_AVAILABLE" ||
                value.supplyCostStatus === "SUPPLY_COST_MANUALLY_UPDATED"
                ? "CONTRACT_AVAILABLE"
                : value.supplyCostStatus === "CONTRACT_EXPIRED"
                ? "#DD800E"
                : "#DD310E"
              : "#1B8EF8",
          onAmountEdit: this.updateSupplyData
        },
        assign: {
          status: value.status,
          isDriverDetailAvailable: !!value.driverDetails,
          assign: this.assignToOperator,
          isAssigned: value.assignedToOperator,
          _id: value._id,
          driverDetails: this.getDriverDetails(
            value.driverDetails,
            value.vehicleDetails
          ),
          type: value.type ? value.type : "DYNAMIC"
        },
        variableType: {
          type: value.type ? value.type : "DYNAMIC",
          _id:
            value.service && value.service.name
              ? this.renderTooltip(value.service.name)
              : null
        },
        trackCab: {
          _id: value._id,
          open: this.openTrackCab
        },
        actions: {
          canEdit,
          _id: value._id,
          edit: this.editData,
          logs: this.showLogs,
          InvoiceStatus:
            value.invoice && value.invoice.status
              ? value.invoice.status
              : "REJECTED"
        },
        bookings: booking
      };
      return data;
    });
    return tableData;
  };

  renderTooltip = name => {
    return (
      <div className={less.Tooltip}>
        <p>Trip:</p>
        <p>{name}</p>
        <img
          onClick={() => this.copyData(name)}
          src="https://d1flzashw70bti.cloudfront.net/original/test/tracer/copywhite.svg"
          alt="copywhite"
        />
      </div>
    );
  };

  handleExpandedRowRender = record => {
    const data = this.listData(record.bookings);
    return data;
  };

  handleRowExpand = (expanded, record) => {
    this.setState(prevState => {
      const { expandedRowKeys } = prevState;
      if (expanded) {
        return { expandedRowKeys: [...expandedRowKeys, record.key] };
      } else {
        return {
          expandedRowKeys: expandedRowKeys.filter(key => key !== record.key)
        };
      }
    });
  };

  listData = bookings => {
    const { coreServiceNames, expandedBookings } = this.state;
    let x = 1;

    if (!bookings) {
      return <span>No Booking found</span>;
    } else
      return bookings.map((booking, index) => (
        <div key={index} className={less.listData}>
          <div>
            <span>{x++}</span>
          </div>
          <div className={less.stationDetail}>
            <div>
              <span>PNR : </span>
              <span>{booking.connectingBookingCode}</span>
            </div>
            <div>
              <span>Leg PNR : </span>
              <span>{booking.bookingCode}</span>
            </div>
          </div>
          {booking.cabServiceType === "LASTMILE" ? (
            booking.isOnboarded ? (
              <div className={less.boardingStatus}>
                <span>Boarded Bus</span>
              </div>
            ) : (
              <div className={less.notBoardingStatus}>
                <span>Not Boarded Bus</span>
              </div>
            )
          ) : null}

          <div>
            <span>Seats : </span>
            <span>{getSeatNumberFromTripChart(booking.tripChart) || "NA"}</span>
          </div>
          <div className={less.stationDetail}>
            <div>
              <span>Pickup Station : </span>
              <span>
                {booking.fromStation ? booking.fromStation.name : null}
              </span>
            </div>
            <div>
              <span>Drop Station : </span>
              <span>{booking.toStation ? booking.toStation.name : null}</span>
            </div>
          </div>
          <div className={less.status}>
            <span
              style={{
                color: booking.status == "CANCELLED" ? "#ED1E21" : "#69AC39"
              }}
            >
              {booking.status}{" "}
            </span>
          </div>

          <div className={less.stationDetail}>
            <div>
              <span>Pickup Time : </span>
              <span>
                {moment(parseInt(booking.fromStationDate)).format("h:mm a")}
              </span>
            </div>
            <div>
              <span>Drop Time : </span>
              <span>
                {" "}
                {moment(parseInt(booking.toStationDate)).format("h:mm a")}
              </span>
            </div>
          </div>
          <div className={less.serviceName}>
            <div
              className={less.service}
              onClick={() => this.toggleDetails(booking._id)}
            >
              <span>
                {expandedBookings[booking._id]
                  ? "Hide Details"
                  : "View Details"}
              </span>

              <img
                src={
                  expandedBookings[booking._id]
                    ? "https://d1flzashw70bti.cloudfront.net/original/images/tracer/arrow.svg"
                    : "https://d1flzashw70bti.cloudfront.net/original/images/tracer/arrowView.svg"
                }
                alt="toggleArrow"
              />
            </div>

            {expandedBookings[booking._id] && (
              <div className={less.serviceCopy}>
                <span>{coreServiceNames[booking._id]}</span>
                <img
                  onClick={() => this.copyData(coreServiceNames[booking._id])}
                  src="https://d1flzashw70bti.cloudfront.net/original/images/tarcer/copy.svg"
                  alt="copy"
                />
              </div>
            )}
          </div>

          <div className={less.remove}>
            <span
              onClick={() =>
                this.removeTrip(booking._id, booking.cabBookingGroupId)
              }
            >
              Remove
            </span>
          </div>
        </div>
      ));
  };

  removeTrip = async (bookingId, cabGroupId) => {
    const { operatorData } = this.state;
    let body = {
      cabBookingGroupId: cabGroupId,
      bookingIdsToRemove: [bookingId]
    };
    const url = `/cabOperator/removeTripToBooking`;

    const options = {
      method: "post",
      data: { details: body }
    };
    const response = await Fetch(url, options);
    if (Array.isArray(response)) {
      const updatedOperatorData = operatorData.map(operator => {
        const updatedResponse = response.find(
          item => item._id === operator._id
        );

        if (updatedResponse) {
          return updatedResponse; // replace operator with updatedResponse
        }
        return operator;
      });

      const data = this.formatData(updatedOperatorData);

      this.setState({
        operatorTableData: data,
        operatorData: updatedOperatorData
      });
      message.success("Booking is Removed");
    } else {
      message.error(response);
    }
  };

  fetchCoreService = async bookingId => {
    const url = `/cabOperator/getServiceName/${bookingId}`;

    const options = {
      method: "get"
    };
    const response = await Fetch(url, options);
    if (response) {
      this.setState(prevState => ({
        coreServiceNames: {
          ...prevState.coreServiceNames,
          [bookingId]: response
        }
      }));
    } else {
      return [];
    }
  };

  toggleDetails = async bookingId => {
    this.setState(prev => {
      const isExpanded = prev.expandedBookings[bookingId];

      return {
        expandedBookings: {
          ...prev.expandedBookings,
          [bookingId]: !isExpanded
        }
      };
    });

    if (!this.state.coreServiceNames[bookingId]) {
      await this.fetchCoreService(bookingId);
    }
  };

  showCreateTripModal = async () => {
    this.setState({
      showCreateModal: true,
      assetType: "",
      assetTypeValues: [],
      showErrowMessage: false,
      tripType: "inter",
      cabOperatorId: undefined,
      interValue: {
        startTime: moment()
      },
      cabOperator: null,
      intraValue: {
        startTime: moment()
      }
    });
  };

  getDriverDetails = (data, rcDetails) => {
    return (
      <div className={less.driverDetail}>
        <div>
          <div>
            <span>RC</span>
            <span>{rcDetails && rcDetails.rc ? rcDetails.rc : null}</span>
          </div>
          <img
            onClick={() => this.copyData(rcDetails.rc)}
            src="https://d1flzashw70bti.cloudfront.net/original/images/tracer/copy.svg"
            alt="copy"
          />
        </div>
        <div>
          <div>
            <span>Mobile</span>
            <span>{data && data.mobileNo ? data.mobileNo : null}</span>
          </div>
          <img
            onClick={() => this.copyData(data.mobileNo)}
            src="https://d1flzashw70bti.cloudfront.net/original/images/tracer/copy.svg"
            alt="copy"
          />
        </div>
        <div>
          <div>
            <span>Name</span>
            <span>{data && data.name ? data.name : null}</span>
          </div>
          <img
            onClick={() => this.copyData(data.name)}
            src="https://d1flzashw70bti.cloudfront.net/original/images/tracer/copy.svg"
            alt="copy"
          />
        </div>
      </div>
    );
  };

  handleChange = async (key, value, data) => {
    let stations = [],
      services = [];
    if (key === "tripType" && value === "intra") {
      stations = await this.fetchStations();
    }
    if (key === "variableType" && value == "FIXED") {
      services = await this.fetchServices();
      this.setState({ services });
    }
    if (key === "cabOperatorId") {
      const { cabOperators } = this.state;
      const selectedOperator = cabOperators.find(op => op._id === data.key);
      const assetTypeValues = selectedOperator
        ? (selectedOperator.assets || []).map(asset => ({
            name: asset.assetName,
            id: asset.assetName
          }))
        : [];
      this.setState({
        [key]: data.key,
        cabOperator: value,
        assetTypeValues,
        assetType: ""
      });
    } else if (key === "updatedSupplyCost") {
      this.setState({ updatedSupplyCost: value ? value : 0 });
    } else this.setState({ [key]: value, stations });
  };

  fetchServices = async () => {
    try {
      const url = `/bus-tracker/getServicesCache`;

      const response = await fetchCached(url);
      if (response) {
        const cabSelectedTrips = response.filter(
          obj =>
            obj.cabServiceType === "FIRSTMILE" ||
            obj.cabServiceType === "LASTMILE"
        );
        return cabSelectedTrips;
      } else {
        return [];
      }
    } catch (err) {
      console.log(err);
      return [];
    }
  };

  fetchStations = async () => {
    try {
      const url = `/bus-tracker/getStationsCache`;

      const response = await fetchCached(url);
      if (response) {
        return response;
      } else {
        return [];
      }
    } catch (err) {
      console.log(err);
      return [];
    }
  };

  fetchOperators = async () => {
    const url = `/cabOperator/getOperator`;

    const response = await fetchCached(url, SHORT_TTL);

    return response;
  };
  createCabGroup = async () => {
    const {
      cabOperatorId,
      assetType,
      interValue,
      intraValue,
      tripType,
      variableType,
      serviceNameId,
      userName
    } = this.state;
    let details = {
      cabOperatorId,
      assetType
    };

    if (tripType == "inter") {
      if (
        !cabOperatorId ||
        !assetType ||
        !interValue.toCityId ||
        !interValue.fromCityId ||
        !interValue.startTime
      ) {
        this.setState({ showErrowMessage: true });
        return;
      }
      details = {
        ...details,
        ...interValue
      };
    } else {
      details = {
        ...details,
        ...intraValue
      };

      details = {
        cabOperatorId: details.cabOperatorId,
        assetType: details.assetType,
        fromStationId: details.fromStationId,
        toStationId: details.toStationId,
        startTime: details.startTime,
        isIntraCity: true,
        fromCityId: details.cityId,
        toCityId: details.cityId
      };

      if (
        !cabOperatorId ||
        !assetType ||
        !details.fromStationId ||
        !details.toStationId ||
        !details.fromCityId ||
        !details.startTime
      ) {
        this.setState({ showErrowMessage: true });
        return;
      }
    }
    if (variableType === "FIXED") {
      if (!serviceNameId) {
        this.setState({ showErrowMessage: true });
        return;
      }
      details.serviceId = serviceNameId;
    }

    const date = new Date(details.startTime);
    const millis = date.getTime();

    details = {
      ...details,
      type: variableType === "FIXED" ? "FIXED" : "DYNAMIC",
      startTime: millis,
      remark: `Contract is created by ${userName} at ${moment().format("LLL")}`
    };

    const url = `/cabOperator/createCabGroup`;

    const options = {
      method: "post",
      data: { details }
    };

    const response = await Fetch(url, options);
    if (Array.isArray(response) && response.length > 0) {
      this.setState({
        assetType: "",
        showErrowMessage: false,
        showCreateModal: false,
        showConfirmationModal: true
      });
    } else {
      this.setState({
        assetType: "",
        showErrowMessage: false,
        showCreateModal: false,
        showErrorModal: true
      });
    }
  };

  setInterCityValues = (key, value, data) => {
    let { interValue = {} } = this.state;
    let newInterValue = interValue;

    if (key === "toCityId") {
      if (data.key == interValue.fromCityId) {
        message.error("Both City can't be same");
        return;
      }
      newInterValue = {
        ...interValue,
        toCity: value,
        toCityId: data.key
      };
      this.setState({ interValue: newInterValue });
    } else if (key === "fromCityId") {
      if (data.key == interValue.toCityId) {
        message.error("Both City can't be same");
        return;
      }
      newInterValue = {
        ...interValue,
        fromCity: value,
        fromCityId: data.key
      };
      this.setState({ interValue: newInterValue });
    } else {
      interValue[key] = value;
      this.setState({ interValue });
    }
  };

  setIntraCityValues = (key, value, data) => {
    let { intraValue = {}, stations } = this.state;
    let newIntraValue = intraValue;
    if (key === "city") {
      let cityId = data.key;
      let intraStations = stations.filter(station => station.cityId == cityId);
      newIntraValue = {
        ...newIntraValue,
        cityId,
        fromStationName: undefined,
        toStationName: undefined,
        city: value
      };
      this.setState({ intraValue: newIntraValue, intraStations });
    } else if (key === "fromStationId") {
      if (intraValue.toStationId && data.key === intraValue.toStationId) return;
      newIntraValue = {
        ...intraValue,
        fromStationName: value,
        fromStationId: data.key
      };
      this.setState({ intraValue: newIntraValue });
    } else if (key === "toStationId") {
      if (intraValue.fromStationId && data.key === intraValue.fromStationId) return;
      newIntraValue = {
        ...newIntraValue,
        toStationName: value,
        toStationId: data.key
      };
      this.setState({ intraValue: newIntraValue });
    } else {
      intraValue[key] = value;

      this.setState({ intraValue });
    }
  };

  onOk = value => {
    const { tripType } = this.state;
    const date = new Date(value);
    const millis = date.getTime();
    if (tripType == "inter") {
      this.setInterCityValues("startTime", millis);
    } else {
      this.setIntraCityValues("startTime", millis);
    }
  };

  editValue = (key, value, data) => {
    const { newEditValues = {}, stations } = this.state;
    let edittedData = newEditValues;
    if (key === "fromCityId") {
      edittedData = {
        ...edittedData,
        edittedFromCity: value,
        edittedFromCityId: data.key
      };
    } else if (key === "toCityId") {
      edittedData = {
        ...edittedData,
        edittedToCity: value,
        edittedToCityId: data.key
      };
    } else if (key === "city") {
      let cityId = data.key;
      let intraStations = stations.filter(station => station.cityId == cityId);
      this.setState({ intraStations });

      edittedData = {
        ...edittedData,
        edittedFromStation: undefined,
        edittedToStation: undefined,
        edittedCity: value,
        edittedCityId: data.key
      };
    } else if (key === "fromStationId") {
      edittedData = {
        ...edittedData,
        edittedFromStation: value,
        edittedFromStationId: data.key
      };
    } else if (key === "toStationId") {
      edittedData = {
        ...edittedData,
        edittedToStation: value,
        edittedToStationId: data.key
      };
    } else if (key === "assetType") {
      edittedData = {
        ...edittedData,
        edittedAssetType: value
      };
    } else if (key === "status") {
      edittedData = {
        ...edittedData,
        edittedStatus: value
      };
    } else if (key === "statusRemark") {
      edittedData = {
        ...edittedData,
        edittedStatusRemark: value
      };
    } else if (key === "assetRemark") {
      edittedData = {
        ...edittedData,
        edittedAssetRemark: value
      };
    } else if (key === "cabOperatorId") {
      const { cabOperators } = this.state;
      const selectedOperator = cabOperators.find(op => op._id === data.key);
      const assetTypeValues = selectedOperator
        ? (selectedOperator.assets || []).map(asset => ({
            name: asset.assetName,
            id: asset.assetName
          }))
        : [];
      this.setState({ assetTypeValues });
      edittedData = {
        ...edittedData,
        edittedAssetType: "",
        edittedCabOperator: value,
        edittedCabOperatorId: data.key
      };
    } else if (key === "startTime") {
      edittedData = {
        ...edittedData,
        edittedStartTime: value
      };
    } else if (key === "serviceSelected") {
      edittedData = {
        ...edittedData,
        edittedServiceNameId: data.key,
        edittedServiceName: value
      };
    }
    this.setState({ newEditValues: edittedData });
  };

  onEditOk = value => {
    const date = new Date(value);
    const millis = date.getTime();
    this.editValue("startTime", millis);
  };

  // Only last_mile_admin edits the status: any status except back to
  // INACTIVE once the trip has started. Others just see the current one.
  getStatusOptions = currentStatus => {
    const { last_mile_admin } = this.state;
    if (!last_mile_admin) return [{ value: currentStatus }];
    return Object.keys(CAB_TRIP_STATUS_LABELS).map(value => ({
      value,
      disabled:
        value === "INACTIVE" && STARTED_TRIP_STATUSES.includes(currentStatus)
    }));
  };

  updateGroup = async () => {
    const { newEditValues = {}, editData, operatorData, userName } = this.state;
    let remark = editData.remark ? `${editData.remark} ` : "";

    const {
      edittedStartTime,
      edittedCabOperatorId,
      edittedCabOperator,
      edittedStatus,
      edittedStatusRemark,
      edittedAssetRemark,
      edittedAssetType,
      edittedToStationId,
      edittedFromStationId,
      edittedCityId,
      edittedToCityId,
      edittedFromCityId,
      edittedToStation,
      edittedFromStation,
      edittedToCity,
      edittedFromCity,
      edittedCity,
      edittedServiceNameId,
      edittedServiceName
    } = newEditValues;
    if (Object.keys(newEditValues).length === 0) {
      message.error("Nothing To Update");
      this.setState({
        showEditModal: false,
        newEditValues: {}
      });
      return;
    }
    if (edittedCabOperatorId && !edittedAssetType) {
      message.error("Asset Type is required when changing the operator");
      return;
    }
    let bodyData = { remark };
    if (edittedCity && (!edittedFromStation || !edittedToStation)) {
      this.setState({ showErrowMessage: true });
      return;
    }
    if (edittedStartTime && edittedStartTime !== editData.startTime) {
      bodyData.remark += `||| startTime is Updated from ${moment(
        editData.startTime
      ).format("h:mm a, DD MMM YY")} to ${moment(edittedStartTime).format(
        "h:mm a, DD MMM YY"
      )} by ${userName} at ${moment().format("LLL")}  `;
      bodyData = { ...bodyData, startTime: edittedStartTime };
    }
    if (
      edittedCabOperatorId &&
      edittedCabOperatorId !== editData.cabOperator._id
    ) {
      bodyData.remark += `||| cab Operator is Updated from ${
        editData.cabOperator.name
      } to ${edittedCabOperator} by ${userName} at ${moment().format("LLL")}  `;
      bodyData = { ...bodyData, cabOperatorId: edittedCabOperatorId };
    }
    if (edittedServiceNameId && edittedServiceNameId !== editData.serviceId) {
      bodyData.remark += `||| service is Updated from ${
        editData.service.name
      } to ${edittedServiceName} by ${userName} at ${moment().format("LLL")}  `;
      bodyData = { ...bodyData, serviceId: edittedServiceNameId };
    }
    if (edittedStatus && !edittedStatusRemark) {
      message.error("Status Cannot be updated without remark");
      return;
    }
    if (edittedStatus && edittedStatus !== editData.status) {
      bodyData.remark += `||| status is Updated from ${
        editData.status
      } to ${edittedStatus} by ${userName} at ${moment().format(
        "LLL"
      )} with remarks ${edittedStatusRemark} `;
      bodyData = { ...bodyData, status: edittedStatus };
    }
    if (edittedAssetType && !edittedAssetRemark) {
      message.error("Asset Cannot be updated without remark");
      return;
    }
    if (edittedAssetType && edittedAssetType !== editData.assetType) {
      bodyData.remark += `||| assetType is Updated from ${
        editData.assetType
      } to ${edittedAssetType} by ${userName} at ${moment().format(
        "LLL"
      )}  with remarks ${edittedAssetRemark} `;
      bodyData = { ...bodyData, assetType: edittedAssetType };
    }
    if (edittedToStationId && edittedToStation !== editData.toStation.name) {
      bodyData.remark += `||| To Station is Updated from ${
        editData.toStation.name
      } to ${edittedToStation} by ${userName} at ${moment().format("LLL")}  `;
      bodyData = { ...bodyData, toStationId: edittedToStationId };
    }
    if (
      edittedFromStationId &&
      edittedFromStation !== editData.fromStation.name
    ) {
      bodyData.remark += `||| From Station is Updated from ${
        editData.fromStation.name
      } to ${edittedFromStation} by ${userName} at ${moment().format("LLL")}  `;
      bodyData = { ...bodyData, fromStationId: edittedFromStationId };
    }
    if (edittedCityId && edittedCity !== editData.fromCity.name) {
      bodyData.remark += `||| City is Updated from ${
        editData.fromCity.name
      } to ${edittedCity} by ${userName} at ${moment().format("LLL")}  `;
      bodyData = {
        ...bodyData,
        fromCityId: edittedCityId,
        toCityId: edittedCityId
      };
    }
    if (edittedToCityId && edittedToCity !== editData.toCity.name) {
      bodyData.remark += `||| To City is Updated from ${
        editData.toCity.name
      } to ${edittedToCity} by ${userName} at ${moment().format("LLL")}  `;
      bodyData = { ...bodyData, toCityId: edittedToCityId };
    }
    if (edittedFromCityId && edittedFromCity !== editData.fromCity.name) {
      bodyData.remark += `||| From City is Updated from ${
        editData.fromCity.name
      } to ${edittedFromCity} by ${userName} at ${moment().format("LLL")}  `;
      bodyData = { ...bodyData, fromCityId: edittedFromCityId };
    }

    if (Object.keys(bodyData).length === 1) {
      message.error("Nothing To Update");
      this.setState({
        showEditModal: false,
        newEditValues: {}
      });
      return;
    }
    if (editData.isIntraCity) {
      bodyData = {
        ...bodyData,
        isIntraCity: true
      };
    }
    // Starting or completing a trip isn't a change to its details, so the
    // driver doesn't get a "Trip Updated" SMS for it
    const onlyStatusChanged = Object.keys(bodyData).every(key =>
      ["remark", "status", "isIntraCity"].includes(key)
    );
    if (
      editData.assignedToOperator &&
      !(onlyStatusChanged && STARTED_TRIP_STATUSES.includes(bodyData.status))
    ) {
      bodyData = {
        ...bodyData,
        triggerCommuntication: true
      };
    }

    const url = `/cabOperator/updateGroup`;

    const options = {
      method: "patch",
      data: { updateBody: bodyData, _id: editData._id }
    };

    const response = await Fetch(url, options);

    if (Array.isArray(response) && response.length > 0) {
      const updatedOperatorData = operatorData.map(operator => {
        const updatedResponse = response.find(
          item => item._id === operator._id
        );

        if (updatedResponse) {
          return { ...operator, ...updatedResponse };
        }
        return operator;
      });
      const data = this.formatData(updatedOperatorData);
      message.success("Trip Is Updated");
      this.setState({
        operatorTableData: data,
        operatorData: updatedOperatorData,
        showEditModal: false,
        newEditValues: {}
      });
    }
  };

  updateSupplyData = async _id => {
    const { operatorData } = this.state;
    let stateObj = { showSupplyModal: true };
    const updateSupply = operatorData.filter(data => data._id == _id)[0];
    stateObj.updateSupply = updateSupply;
    this.setState(stateObj);
  };

  editData = async (_id, canEdit) => {
    const { operatorData, last_mile_admin, cabOperators } = this.state;
    let stateObj = { showEditModal: true };
    if (!canEdit) {
      stateObj.editOnlySttaus = true;
    }
    if (last_mile_admin) {
      stateObj.editOnlySttaus = false;
    }
    const editData = operatorData.filter(data => data._id == _id)[0];
    if (editData.isIntraCity) {
      const stations = await this.fetchStations();
      const intraStations = stations.filter(
        station => station.cityId == editData.fromCityId
      );
      stateObj.stations = stations;
      stateObj.intraStations = intraStations;
    }
    if (editData.type === "FIXED") {
      stateObj.services = await this.fetchServices();
    }
    stateObj.editData = editData;
    const existingOperator = cabOperators.find(
      op => op._id === editData.cabOperator._id
    );
    stateObj.assetTypeValues = existingOperator
      ? (existingOperator.assets || []).map(asset => ({
          name: asset.assetName,
          id: asset.assetName
        }))
      : [];
    this.setState(stateObj);
  };
  copyData = value => {
    navigator.clipboard
      .writeText(value)
      .then(() => {
        message.success("copied");
      })
      .catch(err => {
        console.error("Error copying text: ", err);
      });
  };

  showLogs = _id => {
    let stateObj = { showLogModal: true };

    const { operatorData } = this.state;
    let matchedData = operatorData.find(data => data._id == _id);
    let logs = matchedData ? matchedData.remark : undefined;
    if (logs) {
      const statusParts = logs.split(" ||| ");

      const updateRegex = /(.+?) is Updated from (.+?) to (.+?) by ([\w\s]+) at (.+)/;
      const supplyRegex = /(.+?) is Updated from (.+?) to (.+?) by ([\w\s]+) at (.+?) with remarks (.+)/;
      const addRegex = /([a-f0-9]{24}) added by ([\w\s]+) at (.+)/;
      const removeRegex = /([a-f0-9]{24}) removed by ([\w\s]+) at (.+)/;

      let parts = statusParts
        .map(status => {
          let match = status.match(supplyRegex);
          if (match) {
            return {
              value: match[1], // Value being updated
              oldValue: match[2], // Old value
              newValue: match[3], // New value
              actor: match[4], // Actor (who made the change)
              time: match[5], // Time of the change
              remark: match[6] // Remark of the change
            };
          }

          match = status.match(updateRegex);
          if (match) {
            return {
              value: match[1], // Value being updated
              oldValue: match[2], // Old value
              newValue: match[3], // New value
              actor: match[4], // Actor (who made the change)
              time: match[5] // Time of the change
            };
          }

          match = status.match(addRegex);
          if (match) {
            return {
              value: match[1], // Value being added (e.g., asset ID or other identifier)
              oldValue: "", // No old value for "Added" logs
              newValue: "Added", // No new value for "Added" logs
              actor: match[2], // Actor (who made the addition)
              time: match[3] // Time of the addition
            };
          }

          match = status.match(removeRegex);
          if (match) {
            return {
              value: match[1], // Value being removed (e.g., asset ID or other identifier)
              oldValue: "", // No old value for "Removed" logs
              newValue: "Removed", // No new value for "Removed" logs
              actor: match[2], // Actor (who made the removal)
              time: match[3] // Time of the removal
            };
          }

          return null;
        })
        .filter(item => item !== null);

      const logsColoumn = [
        {
          title: "Value",
          dataIndex: "value",
          key: "value"
        },
        {
          title: "Old Value",
          dataIndex: "oldValue",
          key: "oldValue"
        },
        {
          title: "Updated Value",
          dataIndex: "newValue",
          key: "newValue"
        },
        {
          title: "Actor",
          dataIndex: "actor",
          key: "actor"
        },
        {
          title: "Time",
          dataIndex: "time",
          key: "time"
        },
        {
          title: "Remark",
          dataIndex: "remark",
          key: "remark"
        }
      ];

      stateObj.logsColoumn = logsColoumn;
      stateObj.parts = parts;

      this.setState(stateObj);
    } else {
      message.error("No matching logs found");
    }
  };

  assignToOperator = async (_id, status) => {
    if (status === "INACTIVE") {
      message.error("INACTIVE Trips cannot be Assigned to Operator");
      return;
    }
    const { operatorData } = this.state;
    const updateBody = {
      assignedToOperator: true
    };
    const url = `/cabOperator/updateGroup`;

    const options = {
      method: "patch",
      data: { updateBody, _id: _id }
    };
    const response = await Fetch(url, options);

    if (Array.isArray(response) && response.length > 0) {
      const updatedOperatorData = operatorData.map(operator => {
        const updatedResponse = response.find(
          item => item._id === operator._id
        );

        if (updatedResponse) {
          return { ...operator, ...updatedResponse };
        }
        return operator;
      });
      const data = this.formatData(updatedOperatorData);

      this.setState({
        operatorTableData: data,
        operatorData: updatedOperatorData,
        showEditModal: false
      });
    }
  };

  searchData = response => {
    const data = this.formatData(response);
    this.setState({
      operatorTableData: data,
      operatorData: response
    });
  };

  getDisabledTime = current => {
    if (!current) return {};
    const isToday = current.isSame(moment(), "day");
    const currentHour = moment().hour();

    return {
      disabledHours: () => {
        if (isToday) {
          let hoursToDisable = [];
          for (let i = 0; i < currentHour; i++) {
            hoursToDisable.push(i);
          }
          return hoursToDisable;
        }
        return [];
      },
      disabledMinutes: hour => {
        if (hour === moment().hour()) {
          let currentMinute = moment().minute();
          let minutesToDisable = [];
          for (let i = 0; i < currentMinute; i++) {
            minutesToDisable.push(i);
          }
          return minutesToDisable;
        }
        return [];
      }
    };
  };

  updateCabOperatorContract = async () => {
    const {
      updatedRemark,
      updatedSupplyCost,
      updateSupply,
      operatorData,
      userName
    } = this.state;
    let remark = updateSupply.remark ? `${updateSupply.remark} ` : "";
    if (!updatedRemark || updatedSupplyCost == null) {
      message.error("Both Fields are mandatoy");
      return;
    }
    let bodyData = { remark };
    if (
      updatedSupplyCost !== null &&
      updatedSupplyCost !== updateSupply.supplyCost
    ) {
      bodyData.remark += `||| Supply Cost is Updated from ${
        updateSupply.supplyCost ? updateSupply.supplyCost : null
      } to ${updatedSupplyCost} by ${userName} at ${moment().format(
        "LLL"
      )}  with remarks ${updatedRemark} `;
      bodyData = { ...bodyData, supplyCost: updatedSupplyCost };
    }
    if (updateSupply.isIntraCity) {
      bodyData = {
        ...bodyData,
        isIntraCity: true
      };
    }
    if (updateSupply.assignedToOperator) {
      bodyData = {
        ...bodyData,
        triggerCommuntication: true
      };
    }
    const url = `/cabOperator/updateGroup`;

    const options = {
      method: "patch",
      data: { updateBody: bodyData, _id: updateSupply._id }
    };

    const response = await Fetch(url, options);

    if (Array.isArray(response) && response.length > 0) {
      const updatedOperatorData = operatorData.map(operator => {
        const updatedResponse = response.find(
          item => item._id === operator._id
        );

        if (updatedResponse) {
          return { ...operator, ...updatedResponse };
        }
        return operator;
      });
      const data = this.formatData(updatedOperatorData);
      message.success("Trip Is Updated");
      this.setState({
        updatedRemark: undefined,
        updatedSupplyCost: undefined,
        operatorTableData: data,
        operatorData: updatedOperatorData,
        showSupplyModal: false,
        updateSupply: {}
      });
    }
  };

  handleServiceChange = async (key, value, data) => {
    if (key === "serviceSelected") {
      this.setState({
        serviceName: value,
        serviceNameId: data.key
      });
    }
    return;
  };

  render() {
    const {
      loading,
      contentLoading,
      operatorTableData,
      cities,
      editData = {},
      showEditModal,
      editOnlySttaus,
      interValue = {},
      cabOperator,
      showCreateModal,
      intraStations = [],
      tripType,
      intraValue = {},
      cabOperators = [],
      assetTypeValues = [],
      assetType,
      showConfirmationModal,
      showErrorModal,
      showLogModal,
      parts,
      showErrowMessage = false,
      logsColoumn,
      newEditValues,
      showSupplyModal,
      updatedRemark,
      updatedSupplyCost,
      updateSupply,
      variableType,
      serviceName,
      services = [],
      last_mile_admin
    } = this.state;

    if (loading) {
      return <Loader />;
    } else {
      return (
        <div>
          <div style={{ marginBottom: "10px" }}>
            <Search
              cabOperators={cabOperators}
              showLoader={this.showLoading}
              cities={cities}
              showCreateModal={this.showCreateTripModal}
              onSearch={this.searchData}
            />
          </div>
          <hr />
          <Table
            scroll={{ y: "70vh", x: "160%" }}
            loading={contentLoading}
            columns={columns}
            pagination={false}
            dataSource={operatorTableData}
            onRow={this.getRowProps}
            expandable={{
              expandedRowRender: record => this.handleExpandedRowRender(record),
              expandIcon: ({ expanded, onExpand, record }) => (
                <div
                  className={less.expandDetail}
                  onClick={() => onExpand(record, !expanded)}
                >
                  <img
                    src={
                      expanded
                        ? "https://d1flzashw70bti.cloudfront.net/original/images/tracer/caretdown.svg"
                        : "https://d1flzashw70bti.cloudfront.net/original/images/bookingdown.svg"
                    }
                    alt="show/hide"
                    style={{
                      width: 20,
                      height: 20
                    }}
                  />
                </div>
              ),
              onExpand: this.handleRowExpand,
              columnWidth: "5%"
            }}
          />
          {this.state.trackCabGroupId && (
            <TrackCabModal
              cabGroupIds={[this.state.trackCabGroupId]}
              onClose={() => this.setState({ trackCabGroupId: null })}
            />
          )}
          {showEditModal ? (
            <Modal
              closable={false}
              visible={showEditModal}
              onCancel={() =>
                this.setState({
                  newEditValues: {},
                  showEditModal: false,
                  updateBody: {},
                  assetTypeValues: []
                })
              }
              onOk={this.updateGroup}
            >
              <div className={less.createModal}>
                <div className={less.heading}>
                  <span>Edit Trip</span>
                  <div>
                    <span>
                      {editData.fromCity.name} {editData.toCity.name}
                    </span>
                    <span>{moment(editData.startTime).format("h:mm a")}</span>
                  </div>
                </div>
                {editData.type === "FIXED" && !editOnlySttaus ? (
                  <div>
                    <span>
                      Search Service <span style={{ color: "red" }}>*</span>
                    </span>
                    <Select
                      placeholder="Service Name"
                      showSearch
                      style={{ width: 450 }}
                      onChange={(value, key) =>
                        this.editValue("serviceSelected", value, key)
                      }
                      value={
                        newEditValues && newEditValues.edittedServiceName
                          ? newEditValues.edittedServiceName
                          : editData.service && editData.service.name
                          ? editData.service.name
                          : null
                      }
                      filterOption={(input, option) =>
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {services.map(s => (
                        <Option value={s.name} key={s._id}>
                          {s.name}
                        </Option>
                      ))}
                    </Select>
                  </div>
                ) : null}
                <div>
                  <span>Connecting Type*</span>
                  <Select
                    disabled
                    style={{ width: 450 }}
                    defaultValue={editData.isIntraCity ? "intra" : "inter"}
                    placeholder="Select"
                  >
                    <Option value="inter">Inter</Option>
                    <Option value="intra">Intra</Option>
                  </Select>
                </div>
                {!editData.isIntraCity ? (
                  <div className={less.typeSelector}>
                    <div>
                      <span>From City*</span>
                      <Select
                        disabled={editOnlySttaus}
                        showSearch
                        style={{ width: 450 }}
                        value={
                          newEditValues && newEditValues.edittedFromCity
                            ? newEditValues.edittedFromCity
                            : editData.fromCity.name
                        }
                        onChange={(value, data) =>
                          this.editValue("fromCityId", value, data)
                        }
                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {cities
                          .filter(city => city._id !== (newEditValues && newEditValues.edittedToCityId ? newEditValues.edittedToCityId : editData.toCity._id))
                          .map(city => (
                            <Option value={city.name} key={city._id}>
                              {city.name}
                            </Option>
                          ))}
                      </Select>
                    </div>
                    <div>
                      <span>To City*</span>
                      <Select
                        disabled={editOnlySttaus}
                        showSearch
                        style={{ width: 450 }}
                        value={
                          newEditValues && newEditValues.edittedToCity
                            ? newEditValues.edittedToCity
                            : editData.toCity.name
                        }
                        onChange={(value, data) =>
                          this.editValue("toCityId", value, data)
                        }
                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {cities
                          .filter(city => city._id !== (newEditValues && newEditValues.edittedFromCityId ? newEditValues.edittedFromCityId : editData.fromCity._id))
                          .map(city => (
                            <Option value={city.name} key={city._id}>
                              {city.name}
                            </Option>
                          ))}
                      </Select>
                    </div>
                  </div>
                ) : (
                  <div className={less.typeSelector}>
                    <div>
                      <span>City*</span>
                      <Select
                        disabled={editOnlySttaus}
                        showSearch
                        style={{ width: 450 }}
                        value={
                          newEditValues && newEditValues.edittedCity
                            ? newEditValues.edittedCity
                            : editData.fromCity.name
                        }
                        onChange={(value, data) =>
                          this.editValue("city", value, data)
                        }
                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {cities.map(city => (
                          <Option value={city.name} key={city._id}>
                            {city.name}
                          </Option>
                        ))}
                      </Select>
                    </div>
                    <div>
                      <span>From Station*</span>
                      <Select
                        disabled={editOnlySttaus}
                        showSearch
                        style={{ width: 450 }}
                        placeholder="Select"
                        value={
                          newEditValues &&
                          (newEditValues.edittedFromStation ||
                            newEditValues.edittedCity)
                            ? newEditValues.edittedFromStation
                            : editData.fromStation.name
                        }
                        onChange={(value, data) =>
                          this.editValue("fromStationId", value, data)
                        }
                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {intraStations
                          .filter(s => s._id !== (newEditValues && newEditValues.edittedToStationId ? newEditValues.edittedToStationId : editData.toStation._id))
                          .map(station => (
                            <Option value={station.name} key={station._id}>
                              {station.name}
                            </Option>
                          ))}
                      </Select>
                    </div>
                    <div>
                      <span>To Station*</span>
                      <Select
                        disabled={editOnlySttaus}
                        showSearch
                        style={{ width: 450 }}
                        placeholder="Select"
                        value={
                          newEditValues &&
                          (newEditValues.edittedToStation ||
                            newEditValues.edittedCity)
                            ? newEditValues.edittedToStation
                            : editData.toStation.name
                        }
                        onChange={(value, data) =>
                          this.editValue("toStationId", value, data)
                        }
                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {intraStations
                          .filter(s => s._id !== (newEditValues && newEditValues.edittedFromStationId ? newEditValues.edittedFromStationId : editData.fromStation._id))
                          .map(station => (
                            <Option value={station.name} key={station._id}>
                              {station.name}
                            </Option>
                          ))}
                      </Select>
                    </div>
                  </div>
                )}
                <div>
                  <span>Date and Start Time*</span>
                  <DatePicker
                    disabled={editData.assignedToOperator || editOnlySttaus}
                    style={{ width: 450 }}
                    showTime={{
                      format: "hh:mm A"
                    }}
                    allowClear={false}
                    value={moment(
                      newEditValues && newEditValues.edittedStartTime
                        ? newEditValues.edittedStartTime
                        : editData.startTime
                    )}
                    format="DD-MM-YYYY HH:mm"
                    showNow={false}
                    onOk={this.onEditOk}
                  />
                </div>
                <div className={less.edit}>
                  <div>
                    <span>Operator*</span>
                    <Select
                      disabled={editData.assignedToOperator || editOnlySttaus}
                      showSearch
                      style={{ width: 200 }}
                      onChange={(value, data) =>
                        this.editValue("cabOperatorId", value, data)
                      }
                      value={
                        newEditValues && newEditValues.edittedCabOperator
                          ? newEditValues.edittedCabOperator
                          : editData.cabOperator.name
                      }
                      filterOption={(input, option) =>
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {cabOperators.length > 0
                        ? cabOperators.map(operator => (
                            <Option value={operator.value} key={operator._id}>
                              {operator.value}
                            </Option>
                          ))
                        : null}
                    </Select>
                  </div>

                  <div>
                    <span>Trip Status*</span>
                    <Select
                      style={{ width: 200 }}
                      disabled={!last_mile_admin}
                      value={
                        newEditValues && newEditValues.edittedStatus
                          ? newEditValues.edittedStatus
                          : editData.status
                      }
                      placeholder="Select"
                      onChange={value => this.editValue("status", value)}
                    >
                      {this.getStatusOptions(editData.status).map(status => (
                        <Option
                          key={status.value}
                          value={status.value}
                          disabled={status.disabled}
                        >
                          {CAB_TRIP_STATUS_LABELS[status.value]}
                        </Option>
                      ))}
                    </Select>
                  </div>
                </div>
                {newEditValues && newEditValues.edittedStatus ? (
                  <div>
                    <span>Remark For Status Update*</span>
                    <Input
                      style={{ width: 450 }}
                      type="text"
                      placeholder="Enter Status Update Remark"
                      onChange={e =>
                        this.editValue("statusRemark", e.target.value)
                      }
                    />
                  </div>
                ) : null}

                <div>
                  <span>Asset Type*</span>
                  <Select
                    style={{ width: 450 }}
                    value={
                      newEditValues && newEditValues.edittedAssetType
                        ? newEditValues.edittedAssetType
                        : newEditValues && newEditValues.edittedCabOperatorId
                        ? undefined
                        : editData.assetType
                    }
                    placeholder="Select"
                    disabled={assetTypeValues.length === 0}
                    onChange={value => this.editValue("assetType", value)}
                  >
                    {assetTypeValues.map(asset => (
                      <Option value={asset.name} key={asset.id}>
                        {asset.name}
                      </Option>
                    ))}
                  </Select>
                  {assetTypeValues.length === 0 && (
                    <span style={{ color: "red", fontSize: 12 }}>
                      No assets configured for this operator
                    </span>
                  )}
                </div>
                {newEditValues && newEditValues.edittedAssetType ? (
                  <div>
                    <span>Remark For Asset Update*</span>
                    <Input
                      style={{ width: 450 }}
                      type="text"
                      placeholder="Enter Asset Update Remark"
                      onChange={e =>
                        this.editValue("assetRemark", e.target.value)
                      }
                    />
                  </div>
                ) : null}

                {showErrowMessage ? (
                  <span className={less.error}> All Fields Are mandatory</span>
                ) : null}
              </div>
            </Modal>
          ) : null}
          <Modal
            title="Create a Cab Trip"
            visible={showCreateModal}
            onCancel={() =>
              this.setState({
                assetType: "",
                assetTypeValues: [],
                showCreateModal: false,
                showErrowMessage: false,
                variableType: "DYNAMIC",
                serviceName: undefined,
                serviceNameId: undefined
              })
            }
            onOk={this.createCabGroup}
          >
            <div className={less.createModal}>
              {last_mile_admin ? (
                <div>
                  <span>
                    Contract Type <span style={{ color: "red" }}>*</span>
                  </span>
                  <Radio.Group
                    onChange={e =>
                      this.handleChange("variableType", e.target.value)
                    }
                    value={variableType}
                  >
                    <Radio value={"FIXED"}>Fixed</Radio>
                    <Radio value={"DYNAMIC"}>Dynamic</Radio>
                  </Radio.Group>
                </div>
              ) : null}

              {variableType === "FIXED" ? (
                <div>
                  <span>
                    Search Service <span style={{ color: "red" }}>*</span>
                  </span>
                  <Select
                    placeholder="Service Name"
                    showSearch
                    style={{ width: 450 }}
                    value={serviceName}
                    onChange={(value, key) =>
                      this.handleServiceChange("serviceSelected", value, key)
                    }
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {services.map(s => (
                      <Option value={s.name} key={s._id}>
                        {s.name}
                      </Option>
                    ))}
                  </Select>
                </div>
              ) : null}
              <div>
                <span>Connecting Type*</span>
                <Select
                  style={{ width: 450 }}
                  value={tripType}
                  placeholder="Select"
                  onChange={value => this.handleChange("tripType", value)}
                >
                  <Option value="inter">Inter</Option>
                  <Option value="intra">Intra</Option>
                </Select>
              </div>
              {tripType == "inter" ? (
                <div className={less.typeSelector}>
                  <div>
                    <span>From City*</span>
                    <Select
                      showSearch
                      style={{ width: 450 }}
                      value={interValue.fromCity}
                      onChange={(value, data) =>
                        this.setInterCityValues("fromCityId", value, data)
                      }
                      filterOption={(input, option) =>
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {cities.map(city => (
                        <Option value={city.name} key={city._id}>
                          {city.name}
                        </Option>
                      ))}
                    </Select>
                  </div>
                  <div>
                    <span>To City*</span>
                    <Select
                      showSearch
                      style={{ width: 450 }}
                      value={interValue.toCity ? interValue.toCity : null}
                      onChange={(value, data) =>
                        this.setInterCityValues("toCityId", value, data)
                      }
                      filterOption={(input, option) =>
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {cities.map(city => (
                        <Option value={city.name} key={city._id}>
                          {city.name}
                        </Option>
                      ))}
                    </Select>
                  </div>
                </div>
              ) : (
                <div className={less.typeSelector}>
                  <div>
                    <span>City*</span>
                    <Select
                      showSearch
                      style={{ width: 450 }}
                      value={intraValue.city}
                      onChange={(value, data) =>
                        this.setIntraCityValues("city", value, data)
                      }
                      filterOption={(input, option) =>
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {cities.map(city => (
                        <Option value={city.name} key={city._id}>
                          {city.name}
                        </Option>
                      ))}
                    </Select>
                  </div>
                  <div>
                    <span>From Station*</span>
                    <Select
                      showSearch
                      style={{ width: 450 }}
                      placeholder="Select"
                      value={intraValue.fromStationName}
                      onChange={(value, data) =>
                        this.setIntraCityValues("fromStationId", value, data)
                      }
                      filterOption={(input, option) =>
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {intraStations
                        .filter(s => s._id !== intraValue.toStationId)
                        .map(station => (
                          <Option value={station.name} key={station._id}>
                            {station.name}
                          </Option>
                        ))}
                    </Select>
                  </div>
                  <div>
                    <span>To Station*</span>
                    <Select
                      showSearch
                      style={{ width: 450 }}
                      placeholder="Select"
                      value={intraValue.toStationName}
                      onChange={(value, data) =>
                        this.setIntraCityValues("toStationId", value, data)
                      }
                      filterOption={(input, option) =>
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {intraStations
                        .filter(s => s._id !== intraValue.fromStationId)
                        .map(station => (
                          <Option value={station.name} key={station._id}>
                            {station.name}
                          </Option>
                        ))}
                    </Select>
                  </div>
                </div>
              )}
              <div>
                <span>Date and Start Time*</span>
                <DatePicker
                  style={{ width: 450 }}
                  showTime={{
                    format: "hh:mm A"
                  }}
                  value={
                    tripType == "inter" && interValue.startTime
                      ? moment(interValue.startTime)
                      : tripType == "intra" && intraValue.startTime
                      ? moment(intraValue.startTime)
                      : null
                  }
                  allowClear={false}
                  disabledTime={
                    !last_mile_admin ? this.getDisabledTime : undefined
                  }
                  disabledDate={
                    !last_mile_admin
                      ? currentDate =>
                          currentDate.isBefore(moment().startOf("day"), "day")
                      : undefined
                  }
                  format="DD-MM-YYYY HH:mm"
                  showNow={false}
                  onOk={this.onOk}
                />
              </div>

              <div>
                <span>Operator*</span>
                <Select
                  showSearch
                  style={{ width: 450 }}
                  onChange={(value, data) =>
                    this.handleChange("cabOperatorId", value, data)
                  }
                  value={cabOperator}
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {cabOperators.map(operator => (
                    <Option value={operator.value} key={operator._id}>
                      {operator.value}
                    </Option>
                  ))}
                </Select>
              </div>
              <div>
                <span>Asset Type*</span>
                <Select
                  style={{ width: 450 }}
                  value={assetType}
                  placeholder="Select"
                  disabled={cabOperator && assetTypeValues.length === 0}
                  onChange={value => this.handleChange("assetType", value)}
                >
                  {assetTypeValues.map(asset => (
                    <Option value={asset.name} key={asset.id}>
                      {asset.name}
                    </Option>
                  ))}
                </Select>
                {cabOperator && assetTypeValues.length === 0 && (
                  <span style={{ color: "red", fontSize: 12 }}>
                    No assets configured for this operator
                  </span>
                )}
              </div>
              {showErrowMessage ? (
                <span className={less.error}> All Fields Are mandatory</span>
              ) : null}
            </div>
          </Modal>
          <Modal
            centered
            visible={showConfirmationModal}
            footer={null}
            onCancel={() =>
              this.setState({
                showConfirmationModal: false,
                variableType: "DYNAMIC",
                serviceName: undefined,
                serviceNameId: undefined,
                assetType: "",
                assetTypeValues: []
              })
            }
          >
            <div className={less.modalMessages}>
              <img
                src="https://d1flzashw70bti.cloudfront.net/original/images/modal/check.svg"
                alt="ok"
              />
              <div>
                <span>Creation Successful</span>
                <span>Cab trip has been successfully created</span>
              </div>
              <button
                onClick={() =>
                  this.setState({
                    showConfirmationModal: false,
                    variableType: "DYNAMIC",
                    serviceName: undefined,
                    serviceNameId: undefined,
                    assetType: "",
                    assetTypeValues: []
                  })
                }
              >
                <span>OK</span>
              </button>
            </div>
          </Modal>
          <Modal
            visible={showErrorModal}
            centered
            footer={null}
            onCancel={() =>
              this.setState({
                showErrorModal: false,
                variableType: "DYNAMIC",
                serviceName: undefined,
                serviceNameId: undefined,
                assetType: "",
                assetTypeValues: []
              })
            }
          >
            <div className={less.modalMessages}>
              <img
                src="https://d1flzashw70bti.cloudfront.net/original/images/modal/error.svg"
                alt="error"
              />
              <div>
                <span>Creation Failed</span>
                <span>Sorry, we couldn&apos;t create a cab trip</span>
              </div>
              <button
                onClick={() =>
                  this.setState({
                    showErrorModal: false,
                    variableType: "DYNAMIC",
                    serviceName: undefined,
                    serviceNameId: undefined,
                    assetType: "",
                    assetTypeValues: []
                  })
                }
              >
                <span>OK</span>
              </button>
            </div>
          </Modal>
          <Modal
            title="Update Trip Amount"
            visible={showSupplyModal}
            centered
            onCancel={() =>
              this.setState({
                updatedRemark: "",
                updatedSupplyCost: undefined,
                showSupplyModal: false
              })
            }
            footer={null}
          >
            <div className={less.updateAmount}>
              <div>
                <span>Trip Amount *</span>
                <Input
                  style={{ width: 450 }}
                  value={
                    updatedSupplyCost || updatedSupplyCost === 0
                      ? updatedSupplyCost
                      : updateSupply.supplyCost
                  }
                  placeholder="e.g ₹ 450000"
                  type="number"
                  onChange={e =>
                    this.handleChange(
                      "updatedSupplyCost",
                      parseInt(e.target.value)
                    )
                  }
                />
              </div>
              <div>
                <span>Reason for Change *</span>
                <Input
                  style={{ width: 450 }}
                  value={updatedRemark}
                  placeholder="Type reason here"
                  onChange={e =>
                    this.handleChange("updatedRemark", e.target.value)
                  }
                />
              </div>
              <div>
                <button
                  className={less.cancel}
                  onClick={() =>
                    this.setState({
                      updatedRemark: "",
                      updatedSupplyCost: undefined,
                      showSupplyModal: false
                    })
                  }
                >
                  <span>Cancel</span>
                </button>
                <button
                  className={less.ok}
                  onClick={this.updateCabOperatorContract}
                >
                  <span>OK</span>
                </button>
              </div>
            </div>
          </Modal>

          {showLogModal ? (
            <Modal
              width={"70%"}
              title="Logs"
              centered
              visible={showLogModal}
              footer={null}
              onCancel={() => this.setState({ showLogModal: false })}
            >
              <Table
                loading={contentLoading}
                columns={logsColoumn}
                pagination={false}
                dataSource={parts}
              />
            </Modal>
          ) : null}
        </div>
      );
    }
  }
}

export default OperatorCabTrip;
